import { useContext, useEffect, useState } from "react";
import { GiShare } from "react-icons/gi";
import ShareButton from "Components/ShareButton";
import { useDevice } from "common/hooks/useDevice";
import { ButtonWrapper, Title, Wrapper } from "./ArticleSharing.styled";
import { articleTypes } from "../Context/ArticleContext";
import { ArticleContext } from "../Context";

const ArticleSharing = () => {
  const [baseUrl, setBaseUrl] = useState();
  const { screenSize } = useDevice();
  const { refactoredArticle } = useContext<articleTypes>(ArticleContext);
  const { path, title, publications, titleSocial } = refactoredArticle;
  const publication = publications[0];
  useEffect(() => {
    // @ts-ignore
    setBaseUrl(window.location.href);
  }, []);

  return (
    <Wrapper>
      <Title>
        SPREAD THE NEWS
      </Title>
      <ButtonWrapper>
        <ShareButton
          type="email"
          url={`mailto:?subject=${title}&body=${encodeURIComponent(
            publication.url + path
          )}`}
        />
        <ShareButton
          type="twitter"
          url={`https://twitter.com/intent/tweet?text=${title}%20${publication.url}${path}`}
          nativeSharingUrl={`${publication.url}${path}`}
          nativeSharingTitle={title}
          nativeSharingText={titleSocial}
        />
        <ShareButton
          type="facebook"
          url={`https://www.facebook.com/sharer/sharer.php?u=${baseUrl}`}
        />

        {screenSize.medium && (
          <ShareButton
            type="whatsApp"
            url={`whatsapp://send?text=${title} ${publication.url}${path}`}
            nativeSharingUrl={`${publication.url}${path}`}
            nativeSharingTitle={title}
            nativeSharingText={titleSocial}
          />
        )}
      </ButtonWrapper>
    </Wrapper>
  );
};

export default ArticleSharing;
